export const getAdPriority = (path) => {
  return path.split("/").filter((str) => str !== "").length + 1;
};
